import { useEffect, useState } from "react";
import { Mic2 } from "lucide-react";
import { endpoints } from "@/lib/api";

export default function Programs() {
  const [programs, setPrograms] = useState([]);
  useEffect(() => { endpoints.programs().then((r) => setPrograms(r.data)).catch(() => {}); }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto py-10">
      <div className="flex items-center gap-2 mb-2">
        <Mic2 className="w-7 h-7 text-[#E11D2A]" />
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white">Programs</h1>
      </div>
      <p className="text-slate-400 mb-8">Our regular shows and the voices behind them.</p>
      <div className="grid md:grid-cols-2 gap-5">
        {programs.map((p) => (
          <div key={p.id} data-testid={`program-card-${p.id}`} className="rounded-xl bg-[#121620] border border-[#273042] p-6 card-hover">
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-xl bg-[#E11D2A]/15 flex items-center justify-center"><Mic2 className="w-6 h-6 text-[#E11D2A]" /></span>
              <div>
                <div className="text-white font-bold">{p.name}</div>
                {p.host && <div className="text-xs text-slate-400">Hosted by {p.host}</div>}
              </div>
            </div>
            {p.description && <p className="text-slate-400 text-sm mt-4 leading-relaxed">{p.description}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
